import React from 'react';
import IconStart from '@learningblocks/exp-constants/lib/Icons/start-solid';
import PropTypes from 'prop-types';

const OPEN_ICON_STYLE = {
  transform: 'rotate(90deg)',
};
const CLOSE_ICON_STYLE = {
  transform: 'rotate(-90deg)',
};

/**
 * IconOpen :
 *  - Icon to click when you want to open dropdown
 */
export function IconOpen(props) {
  return <IconStart className={props.className} style={OPEN_ICON_STYLE} />;
}

/**
 * IconClose:
 *  - Icon to click when you want to close dropdown.
 */
export function IconClose(props) {
  return <IconStart className={props.className} style={CLOSE_ICON_STYLE} />;
}

const IconPropsTypes = {
  /**
   * ClassName to be set on the icon
   */
  className: PropTypes.string,
};

IconOpen.propTypes = IconPropsTypes;
IconClose.propTypes = IconPropsTypes;
